import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import moment from 'moment';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import './ForecastRow.scss';

const ForecastRow = (props) => {
  const { deal, columns } = props;
  const { is_closed, chats, chat_set } = deal;
  const [isExpanded, setIsExpanded] = useState(null);

  // New Deal Fields
  // const [newCloseDate, setNewCloseDate] = useState(deal.close_date);
  // const [newName, setName] = useState(deal.name);
  // const [newCloseProb, setCloseProb] = useState(deal.close_probability);
  // const [newDealSize, setDealSize] = useState(deal.deal_size);

  const deleteDeal = (deal) => {
    confirmAlert({
      title: 'Just confirming',
      message: 'Are you sure you want to delete this deal?',
      buttons: [
        { label: 'No', className: 'cancel', onClick: () => {} },
        {
          label: 'Yes',
          onClick: () => props.deleteDeal(deal),
        },
      ],
    });
  };

  return (
    <div className={cn('row forecast-row', { closed: is_closed })}>
      <div className='main-data'>
        {columns.map((col, idx) => (
          <div key={idx} className={`cell ${col.classNames}`}>
            {col.displayForDeal(deal)}
          </div>
        ))}
        <KeyboardArrowUp onClick={() => setIsExpanded(!isExpanded)} className={cn('toggle-expand', { expanded: isExpanded })} />
      </div>
      <div className={cn('drawer', { expanded: isExpanded })}>
        {(chats || chat_set)?.length ? (
          <div className='calls'>
            <div className='header'>Recent Calls</div>
            {(chats || chat_set).map((call) => {
              return (
                <Link to={`/calls/${call.id}`} className='call'>
                  <div className='time'>{moment(call.created_at).format('MMM Do')}</div>
                  <div className='name'>{call.chat_name}</div>
                </Link>
              );
            })}
          </div>
        ) : (
          <div className='no-calls-mapped'>No calls mapped to this deal.</div>
        )}
        <div className='actions'>
          <div onClick={() => deleteDeal(deal)} className='action'>
            Delete Deal
          </div>
        </div>
      </div>
    </div>
  );
};

ForecastRow.propTypes = {
  user: PropTypes.object.isRequired,
  deal: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  deleteDeal: PropTypes.func.isRequired,
};

export default ForecastRow;
